import { GlButton, GlModalDirective, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { CANCEL_JOBS_MODAL_ID, CANCEL_JOBS_BUTTON_TEXT, CANCEL_BUTTON_TOOLTIP } from '../constants';
import CancelJobsModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/admin/jobs_table/components/cancel_jobs_modal.vue?vue3';
export default {
    name: 'CancelJobs',
    components: {
        GlButton,
        CancelJobsModal
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective
    },
    props: {
        url: {
            type: String,
            required: true
        }
    },
    emits: [
        'confirm'
    ],
    modalId: CANCEL_JOBS_MODAL_ID,
    buttonText: CANCEL_JOBS_BUTTON_TEXT,
    buttonTooltip: CANCEL_BUTTON_TOOLTIP
};
